/* istanbul ignore file */
import CreateNoteForm from 'domain/sales/shared/timeline/note/form/CreateNoteForm';
import UpdateNoteForm from 'domain/sales/shared/timeline/note/form/UpdateNoteForm';
import NoteTimelineRecordLayout from 'domain/sales/shared/timeline/note/NoteTimelineRecordLayout';
import { UPDATE_CRM_NOTE_PERMISSION } from './crmNoteService';

const useCrmNoteItem = () => ({
  AddForm: CreateNoteForm,
  UpdateForm: UpdateNoteForm,
  isApplicable: (item: { note: any }) => item.note,
  source: 'note',
  urlPostfix: 'notes',
  RecordLayout: NoteTimelineRecordLayout,
  name: 'Note',
  buttonSize: 'small',
  permissionToCheck: UPDATE_CRM_NOTE_PERMISSION,
});

export default useCrmNoteItem;
